const ADMIN_PARTER_SITE = 'fulcrum/container/Admin/PartnerSite/PartnerSite'
const MOUNT = 'fulcrum/container/Admin/PartnerSite/PartnerSite/MOUNT'
const UNMOUNT = 'fulcrum/container/Admin/PartnerSite/PartnerSite/UNMOUNT'
const UPDATE_ACTIVE_DIALOG = 'fulcrum/container/Admin/PartnerSite/PartnerSite/UPDATE_ACTIVE_DIALOG'
const UPDATE_INACTIVE_DIALOG = 'fulcrum/container/Admin/PartnerSite/PartnerSite/UPDATE_INACTIVE_DIALOG'
const UPDATE_ACTIVE_ADD_DIALOG = 'fulcrum/container/Admin/PartnerSite/PartnerSite/UPDATE_ACTIVE_ADD_DIALOG'
const UPDATE_INACTIVE_ADD_DIALOG = 'fulcrum/container/Admin/PartnerSite/PartnerSite/UPDATE_INACTIVE_ADD_DIALOG'

export {
  ADMIN_PARTER_SITE,
  MOUNT,
  UNMOUNT,
  UPDATE_ACTIVE_DIALOG,
  UPDATE_INACTIVE_DIALOG,
  UPDATE_ACTIVE_ADD_DIALOG,
  UPDATE_INACTIVE_ADD_DIALOG
}
